import { render } from "./SelectChallenge.vue?vue&type=template&id=e145a0e2&ts=true"
import script from "./SelectChallenge.vue?vue&type=script&lang=ts"
export * from "./SelectChallenge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__